// Hoists the housevisits portfolio fan-out to a single call shared by all
// portfolio housevisits dashboard cards. Without this, each card would call
// `useHouseVisitsPortfolioData` independently and multiply Firestore reads.
//
// AI-CONTEXT: See docs/patterns.md#dashboard-portfolio-aggregation-card

import { createContext, useContext, useMemo } from 'react'
import useHouseVisitsPortfolioData from '../hooks/housevisitsPortfolio/useHouseVisitsPortfolioData'

/**
 * @typedef {object} PortfolioHouseVisitsValue
 * @property {Array<{CompagnyID: string, CommunityName?: string}>} projects
 * @property {Array<object>} adresses
 * @property {Array<object>} tasks
 * @property {boolean} loading
 */

/** @type {PortfolioHouseVisitsValue} */
const defaultValue = {
    projects: [],
    adresses: [],
    tasks: [],
    loading: false,
}

export const PortfolioHouseVisitsContext = createContext(defaultValue)

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} props.showDemoProjects - Telt demolocaties als actief (CompagnyMeta.ShowDemoProjects)
 */
export const PortfolioHouseVisitsProvider = ({ children, showDemoProjects }) => {
    const { projects, adresses, tasks, loading } = useHouseVisitsPortfolioData(showDemoProjects)

    // Memoize the value so consumers don't re-render when the parent re-renders
    // for unrelated reasons (e.g. dnd-kit drag state on the dashboard).
    const value = useMemo(
        () => ({ projects, adresses, tasks, loading }),
        [projects, adresses, tasks, loading]
    )

    return (
        <PortfolioHouseVisitsContext.Provider value={value}>
            {children}
        </PortfolioHouseVisitsContext.Provider>
    )
}

export const usePortfolioHouseVisits = () => useContext(PortfolioHouseVisitsContext)
